import React, { useContext } from 'react'
import Stack from '@mui/material/Stack'
import EditableTextField from '../../../common/fields/editableTextField'
import OutlinedFieldFormik from '../../../formik/fields/outlinedFieldFormik'
import EmailFieldFormik from '../../../formik/fields/emailFieldFormik'
import SelectMultipleFormik from '../../../formik/fields/selectMultipleFormik'
import SectionForm from '../../../common/sectionForm'
import { ActiveEnterpriseContext } from '../../../../context/activeEnterpriseContext'
import { isMember, getTitles } from '../../../../utils'
import { Option } from '../../../../types'
import useMediaQuery from '@mui/material/useMediaQuery'

interface Props {
  formik: any
  listTitles: Option[]
}

const IdentityForm = ({ formik, listTitles }: Props) => {
  const { activeEnterprise } = useContext(ActiveEnterpriseContext)
  const isMobile = useMediaQuery('(max-width:800px)')

  return (
    <SectionForm title='identité'>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px' sx={{ mb: '24px' }}>
        <EditableTextField
          label='Prénom'
          required
          sx={{ width: isMobile ? '100%' : '318px' }}
          value={formik.values.first_name}
        >
          <OutlinedFieldFormik name='first_name' placeholder='Prénom' />
        </EditableTextField>
        <EditableTextField
          label='Nom'
          required
          sx={{ width: isMobile ? '100%' : '318px', mt: isMobile ? '24px' : 0 }}
          value={formik.values.last_name}
        >
          <OutlinedFieldFormik name='last_name' placeholder='Nom' />
        </EditableTextField>
      </Stack>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px' sx={{ mb: '24px' }}>
        <EditableTextField
          label='Courriel'
          required
          sx={{ width: isMobile ? '100%' : '318px' }}
          value={formik.values.email}
        >
          <EmailFieldFormik name='email' />
        </EditableTextField>
        {isMember(activeEnterprise) && (
          <EditableTextField
            label='Courriel de récupération'
            sx={{ width: isMobile ? '100%' : '318px', mt: isMobile ? '24px' : 0 }}
            value={formik.values.recovery_email}
          >
            <EmailFieldFormik name='recovery_email' />
          </EditableTextField>
        )}
      </Stack>

      {isMember(activeEnterprise) && (
        <EditableTextField
          sx={{ width: isMobile ? '100%' : '318px' }}
          label='Titre'
          value={getTitles(formik.values.titles, listTitles).join(', ')}
          required
        >
          <SelectMultipleFormik
            name='titles'
            placeholder='Titre'
            fullWidth
            selectType
            listItems={(listTitles || []) as Option[]}
          />
        </EditableTextField>
      )}
    </SectionForm>
  )
}

export default IdentityForm